import { OLAF, CALYPSO, HEFFALUMP, FLINT, BATTLESHIP } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { getIconForChannel, getIconForOriginatingGenericChannelId } from 'svh-workspace-ui-lib/preview-card/public/operators';
import { PreviewCardIconAvatar, PreviewCardCheckbox, theme } from './PreviewCardStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREVIEW_CARD_CHANNEL_ICON_SIZE = 16;
const PREVIEW_CARD_CHANNEL_ICON_PADDING = 0.33333333;
const PREVIEW_CARD_CHANNEL_ICON_BORDER_WIDTH = 0;
const DisabledCircle = styled.div.withConfig({
  displayName: "PreviewCardChannelIcon__DisabledCircle",
  componentId: "sc-1hqp58u-0"
})(["background:", " !important;width:", "px;height:", "px;min-width:", "px;border-radius:50%;"], BATTLESHIP, ({
  size
}) => size, ({
  size
}) => size, ({
  size
}) => size);
const getColorMap = ({
  isUnread,
  isSelected
}) => {
  if (isSelected) {
    return {
      color: OLAF,
      backgroundColor: CALYPSO
    };
  }
  if (isUnread) {
    return {
      color: OLAF,
      backgroundColor: HEFFALUMP
    };
  } else {
    return {
      color: OLAF,
      backgroundColor: FLINT
    };
  }
};
const getChannelIconByFallbackIcon = (fallbackIcon, channelId) => fallbackIcon === 'databases' ? getIconForOriginatingGenericChannelId(channelId) : getIconForChannel(channelId);
const ChannelIcon = ({
  isInBatchUpdatesList,
  disabled,
  channelId,
  isUnread,
  isSelected,
  fallbackIcon
}) => {
  if (disabled) return /*#__PURE__*/_jsx(DisabledCircle, {
    size: theme.AVATAR_SIZE
  });
  const channelIcon = channelId ? getChannelIconByFallbackIcon(fallbackIcon, channelId) : fallbackIcon;
  const {
    color,
    backgroundColor
  } = getColorMap({
    isUnread,
    isSelected
  });
  return /*#__PURE__*/_jsx(PreviewCardIconAvatar, {
    checked: isInBatchUpdatesList,
    size: PREVIEW_CARD_CHANNEL_ICON_SIZE,
    name: channelIcon,
    padding: PREVIEW_CARD_CHANNEL_ICON_PADDING,
    color: color,
    backgroundColor: backgroundColor,
    borderWidth: PREVIEW_CARD_CHANNEL_ICON_BORDER_WIDTH,
    "data-test-id": "preview-card-channel-icon"
  });
};
ChannelIcon.displayName = 'ChannelIcon';
export const PreviewCardChannelIcon = ({
  disableBulkSelect,
  disabled,
  onSelect,
  isBulkSelected,
  fallbackIcon,
  channelId,
  isUnread,
  isSelected,
  disableBulkSelectTooltip = false,
  hideBulkSelectCheckbox
}) => {
  const handleCheckboxClick = event => {
    event.stopPropagation();
    event.preventDefault();
    onSelect();
  };
  const disableTooltip = !disableBulkSelect || disableBulkSelect && isBulkSelected || disableBulkSelectTooltip;
  return /*#__PURE__*/_jsxs("div", {
    children: [!hideBulkSelectCheckbox && /*#__PURE__*/_jsx(UITooltip, {
      disabled: disableTooltip,
      maxWidth: 275,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.preview-card.channel-icon-checkbox.tooltip"
      }),
      "data-test-id": "selection-limit-reached-tooltip",
      children: /*#__PURE__*/_jsx(PreviewCardCheckbox, {
        "aria-label": I18n.text('conversations-inbox-ui.preview-card.channel-icon-checkbox.selectConversation'),
        "data-test-id": "bulk-select-checkbox",
        onClick: handleCheckboxClick,
        checked: isBulkSelected,
        disabled: disableBulkSelect && !isBulkSelected
      })
    }), !isBulkSelected && /*#__PURE__*/_jsx(ChannelIcon, {
      disabled: disabled,
      channelId: channelId,
      isUnread: isUnread,
      isSelected: isSelected,
      isInBatchUpdatesList: isBulkSelected,
      fallbackIcon: fallbackIcon
    })]
  });
};
PreviewCardChannelIcon.displayName = 'PreviewCardChannelIcon';
export default PreviewCardChannelIcon;